'use client'

import React, { useRef, useEffect } from "react";
//import { useEditableContent } from "@/contexts/AdminContext";

interface EditableTextProps {
  pageSlug: string;
  contentKey: string;
  defaultValue: string;
  as?: any;
  className?: string;
}

const EditableText: React.FC<EditableTextProps> = ({
  pageSlug,
  contentKey,
  defaultValue,
  as: Tag = "span",
  className = "",
}) => {
  const { value, isEditing, setValue, isOverridden } = /*useEditableContent(pageSlug, contentKey, defaultValue);*/{value: defaultValue, isEditing: false, setValue: null, isOverridden: false} as any
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.innerText !== value) {
      ref.current.innerText = value;
    }
  }, [value, isEditing]);

  if (!isEditing) {
    return <Tag className={className}>{value}</Tag>;
  }

  return React.createElement(Tag, {
    ref,
    className: `${className} outline-none ring-2 ring-primary/30 rounded-sm cursor-text hover:ring-primary/60 focus:ring-primary`,
    contentEditable: true,
    suppressContentEditableWarning: true,
    style: { minWidth: "20px", minHeight: "1em" },
    onBlur: (e: React.FocusEvent<HTMLElement>) => {
      const newText = e.currentTarget.innerText.trim();
      if (newText !== value) {
        setValue(newText);
      }
    },
    children: value,
  });
};

export default EditableText;
